var render, staticRenderFns
import script from "./ChooseSubjectFiles.vue?vue&type=script&lang=js&"
export * from "./ChooseSubjectFiles.vue?vue&type=script&lang=js&"
import style0 from "./ChooseSubjectFiles.vue?vue&type=style&index=0&id=180e8e4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180e8e4e",
  null
  
)

export default component.exports